import { render, staticRenderFns } from "./BuJianKanban.vue?vue&type=template&id=47d94d04&"
import script from "./BuJianKanban.vue?vue&type=script&lang=js&"
export * from "./BuJianKanban.vue?vue&type=script&lang=js&"
import style0 from "./BuJianKanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports